import styled from 'styled-components';
import { Button, Select } from 'antd';
import AButton from '../../../core/components/buttons/AButton';
import { StyledButton } from '../../dashboard/Dashboard.style';
import { createGlobalStyle } from "styled-components";

export const GlobalSelectStyles = createGlobalStyle`
  .ant-select-dropdown {
    .ant-select-item {
      font-size: 17px !important;
    }
  }
`;

export const Container = styled.div`
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
  padding-top: 120px;
  min-height: 100vh;
  padding-bottom: 55px; /* Space for footer */
`;

export const SelectComponentsWrapper = styled.div`
background-color: #e6e6e6 !important;
  flex-wrap: wrap;
  flex-direction: row;
  display: inline-flex;
  justify-content: center;
  gap: 10px;
  align-content: baseline;
  width: 100%;
  height: calc(100vh - 280px);
  overflow-y: auto;

`;

export const FilterSelectInput = styled(Select)`
    &.ant-select {
    border-radius: 20px;
    width: ${(props) => props?.filterlenght};
    overflow: hidden;
    border: 1px solid gainsboro;
    width: 300px;
    box-shadow: 5px 0px 10px 0px rgba(0,0,0,0.15);
    .ant-select-selector {
      border: none;
      outline: none;
      height: 50px;
      .ant-select-selection-search {
        .ant-select-selection-search-input {
          outline: none;
          border: none;
        }
      }
      .ant-select-selection-item {
        display: flex;
        font-size: 18px;
        width: 100%;
        align-self: center;
        justify-content: center;
      }
      /* .ant-select-selector:disabled {
        background-color: red !important;
      }
      &:disabled {
        background-color: red !important;
      } */
    }
    /* .ant-select-disabled {
        background-color: red;
    }
    &:disabled {
        background-color: red !important;
      } */
  }
  box-shadow: 5px 5px 10px 0px rgba(0,0,0,0.15);
`;

export const ChangeShiftButton = styled.button`
  background-color: ${({ theme: { colors } }) => colors.mainColors.blue};
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  cursor: pointer;
  margin: 20px auto;
  display: block;

  &:disabled {
    background-color: #858585;
    cursor: not-allowed;
  }

  @media screen and (max-height: 700px) {
    margin: 10px auto;
  }
`;